import React from 'react';
import { Layout, Row } from 'antd';

const AppFooter: React.FC = () => {
  return (
    <Layout.Footer>
      <Row justify='center'>AutoStream ©2026. Powered by VCMS</Row>
    </Layout.Footer>
  );
};

export default AppFooter;
